import { USERS_AUTHEN } from 'client/api';
import userProvider from 'data-access/user-provider';
import { useQuery } from 'react-query';

export const useGetAuthen = (params, enabled = true) => {
  const { isLoading, data = {} } = useQuery(
    [USERS_AUTHEN, params],
    ({ signal }) => userProvider.getUserAuthen({ params, signal }),
    {
      refetchOnWindowFocus: false,
      enabled
    }
  );

  return {
    isLoading,
    data
  };
};
